import { Box, SvgIcon } from "@mui/material";
import { Gender, Jersey } from "@/models/socketIo/initializeMatchPayload";

export default ({
  gender,
  colorShirt = "#000",
  colorPants = "#000",
  jersey,
}: {
  gender: Gender;
  colorShirt?: string;
  colorPants?: string;
  jersey?: Jersey;
}) => {
  if (jersey) {
    colorShirt = jersey.shirtColorHex;
    colorPants = jersey.shortsColorHex;
  }
  return gender === "MALE" ? (
    <JerseyMale colorShirt={colorShirt} colorPants={colorPants} />
  ) : (
    <JerseyFemale colorShirt={colorShirt} colorPants={colorPants} />
  );
};

const JerseyMale = ({
  colorShirt,
  colorPants,
}: {
  colorShirt: string;
  colorPants: string;
}) => (
  <Box display="flex" flexDirection="column" gap={"0.2em"}>
    <SvgIcon sx={{ height: "10vw", width: "10vw" }}>
      <svg
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 99.4 106.3"
      >
        <title>Trikot-Mann</title>
        <path
          stroke={"#000"}
          fill={colorShirt}
          d="M84.11,45.4v-3H99.4V35.8c0-13.7-7.1-23.1-18.9-25.2-.4-.1-.8-.1-1.2-.2-3.2-.5-8-1.2-9.5-9.2A1.46,1.46,0,0,0,67.1.7L67,.81C65,1.69,59.31,3.7,49.7,3.7,40.33,3.7,34.8,1.79,32.65.88l0-.08A1.62,1.62,0,0,0,31.2.1a1.34,1.34,0,0,0-1.3.8,6.36,6.36,0,0,0-.6,1.8c-.7,2.8-1.7,7-10.5,8C7.8,11.8.5,20.9.1,33.8,0,36.92,0,39.86,0,42.4H15.61v3H0c0,3.5.12,5.75.12,5.8a1.47,1.47,0,0,0,1.5,1.5H19.2V96.1H80.4V52.6H97.9a1.54,1.54,0,0,0,1.5-1.5V45.4ZM49.9,27.6c-2.78-4.41-9.82-15.22-14.54-22.52A54.37,54.37,0,0,0,49.7,6.8,53.73,53.73,0,0,0,64.36,5Z"
        />
        <rect
          stroke={"#000"}
          fill={colorShirt}
          x="19.2"
          y="99.1"
          width="61.2"
          height="7.2"
        />
      </svg>
    </SvgIcon>
    <SvgIcon sx={{ height: "7.6vw", width: "10vw" }}>
      <svg
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 76.9 80.8"
      >
        <title>Hose_Mann</title>
        <path
          stroke={"#000"}
          fill={colorPants}
          className="cls-1"
          d="M70.71,6.9q-.58-2.85-1.21-5.7A1.59,1.59,0,0,0,68,0H8.9A1.63,1.63,0,0,0,7.4,1.1C6.94,3,6.51,5,6.09,6.9Z"
        />
        <path
          stroke={"#000"}
          fill={colorPants}
          className="cls-1"
          d="M0,71.06C0,74.82-.07,77.21-.1,77.3a1.45,1.45,0,0,0,1.4,1.5l29,2a1.53,1.53,0,0,0,1.6-1.3l.83-5.57Z"
        />
        <path
          stroke={"#000"}
          fill={colorPants}
          className="cls-1"
          d="M43.77,71.2l33.1-3c-.11-8.83-.45-22.39-1.57-32.71-1-8.63-2.32-17.15-4-25.6H5.45c-1.73,8.45-3.06,17-3.95,25.6C.58,45.94.22,59.2.06,68l33.11,3L34.9,59.3l3.5-13.1L42,59.3Z"
        />
        <path
          stroke={"#000"}
          fill={colorPants}
          className="cls-1"
          d="M44.21,74.17,45,79.5a1.49,1.49,0,0,0,1.4,1.3l29.1-2a1.52,1.52,0,0,0,1.4-1.5c0-.06,0-2.4,0-6.08Z"
        />
      </svg>
    </SvgIcon>
  </Box>
);

const JerseyFemale = ({
  colorShirt,
  colorPants,
}: {
  colorShirt: string;
  colorPants: string;
}) => (
  <Box display="flex" flexDirection="column" gap={"0.2em"}>
    <SvgIcon sx={{ height: "10vw", width: "10vw" }}>
      <svg
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 99.4 106.3"
      >
        <title>Trikot-Frau</title>
        <polygon
          stroke={"#000"}
          points="19.91 99.1 19.2 106.3 80.4 106.3 79.69 99.1 19.91 99.1"
          fill={colorShirt}
        />
        <path
          stroke={"#000"}
          fill={colorShirt}
          d="M99.4,42.4V35.8c0-13.7-7.1-23.1-18.9-25.2-.4-.1-.8-.1-1.2-.2-3.2-.5-8-1.2-9.5-9.2A1.46,1.46,0,0,0,67.1.7L67,.81C65,1.69,59.31,3.7,49.7,3.7,40.33,3.7,34.8,1.79,32.65.88l0-.08A1.62,1.62,0,0,0,31.2.1a1.34,1.34,0,0,0-1.3.8,6.36,6.36,0,0,0-.6,1.8c-.7,2.8-1.7,7-10.5,8C7.8,11.8.5,20.9.1,33.8,0,36.92,0,39.86,0,42.4H15.6v3H0c0,3.5.12,5.75.12,5.8a1.47,1.47,0,0,0,1.5,1.5H21.42L23.2,65.9l-3,30.2H79.39l-3-30.2,1.79-13.3H97.9a1.54,1.54,0,0,0,1.5-1.5V45.4H84.1v-3ZM49.74,27.54C47,23.13,39.92,12.32,35.2,5A54,54,0,0,0,49.54,6.74,53.75,53.75,0,0,0,64.2,4.93Z"
        />
      </svg>
    </SvgIcon>
    <SvgIcon sx={{ height: "5vw", width: "10vw" }}>
      <svg
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 76.9 51.1"
      >
        <title>Hose_Frau</title>
        <path
          stroke={"#000"}
          fill={colorPants}
          className="cls-1"
          d="M70.71,6.9q-.58-2.85-1.21-5.7A1.59,1.59,0,0,0,68,0H8.9A1.63,1.63,0,0,0,7.4,1.1C6.94,3,6.51,5,6.09,6.9Z"
        />
        <path
          stroke={"#000"}
          fill={colorPants}
          className="cls-1"
          d="M75.3,35.5c-1-8.63-2.32-17.15-4-25.6H5.45A244.14,244.14,0,0,0,1.6,35.6c-.7,8.7-.2,9.6-.2,9.6a2.67,2.67,0,0,0,1,2.1c3.9,1.9,28.7,3.6,30.2,3.7.7,0,1.1-.5,1.8-1.5s3.7-5.6,3.7-5.6l2.6,5.9s.7,1.3,1.5,1.3,29-2,29-2c.8,0,2.5-.1,3.2-.2C76.2,48.8,75.8,41.9,75.3,35.5Z"
        />
      </svg>
    </SvgIcon>
    <Box height={"0.8em"} />
  </Box>
);
